import { SET_VEHICLEDETAIL } from '../actions';

const vehicledetail = (state = [], action) => {
  switch (action.type) {
	case SET_VEHICLEDETAIL:
      return [...action.value];  
    default: return state;
  }
}

export default vehicledetail;
